module.exports = __webpack_public_path__ + "static/media/HourGlassDark.1fa2501c.svg";